<template>
  <div class="product-details">
    <product-badges
      :key="`badges-${product.handle}`"
      class="product-details__badges"
      :badges="product.badges"
      :product="product"
      large
    />

    <div
      v-if="product.vendor"
      class="product-details__vendor-container"
    >
      <a
        class="product-details__vendor text-heading-s text-heading-m-desktop"
        :href="vendorCollectionUrl"
        v-text="product.vendor"
      />
    </div>

    <wishlist-button
      class="product-details__wishlist-button"
      :product="product"
      template="form"
      :variant="variant ? variant : product.variants[0]"
    />

    <h1
      id="template-title"
      class="product-details__title text-body-xs text-body-s-desktop"
      v-text="product.product_title"
    />

    <product-prices
      :available="product?.available"
      class="text-heading-xs"
      :compare-at-price="compareAtPrice"
      :is-coming-soon="product?.isComingSoon"
      :price="price"
      :varies="varies"
    />

    <div class="product-details__payments">
      <klarna-messaging
        class="product-details__klarna"
        namespace="product-details"
        :price="price"
        :variant="variant"
      />

      <afterpay-messaging
        v-if="variant"
        class="product-details__afterpay"
        namespace="product-details"
        :price="price"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product details (product-details)
 * -----------------------------------------------------------------------------
 * Product page details.
 *
 * @param {Object} product - Liquid local product object.
 * @param {Object|Boolean} variant - Canvas formatted variant object.
 *
 */
import AfterpayMessaging from '~async/afterpay-messaging/afterpay-messaging'
import KlarnaMessaging from '~async/klarna-messaging/klarna-messaging'
import ProductBadges from '~async/product-badges/product-badges'
import ProductPrices from '~global/product-prices/product-prices'
import WishlistButton from '~async/wishlist-button/wishlist-button'

export default {
  name: 'ProductDetails',

  components: {
    AfterpayMessaging,
    KlarnaMessaging,
    ProductBadges,
    ProductPrices,
    WishlistButton,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: () => ({
        compareAtPrice: {},
        price: {},
        variants: [],
      }),
      required: true,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
  },

  data() {
    return {

    }
  },

  computed: {

    /**
     * Compute compare at price to display.
     * @returns {Number}
     */
    compareAtPrice() {
      return this.variant
        ? this.variant.compareAtPrice?.amount
        : this.product.compareAtPrice?.amount
    },

    /**
     * Compute price to display.
     * @returns {Number}
     */
    price() {
      return this.variant
        ? this.variant.price?.amount
        : this.product.price?.amount
    },

    /**
     * Compute if price varies.
     * @return {Boolean}
     */
    varies() {
      return !this.variant && this.product.price?.varies
    },

    /**
     * Compute vendor collection URL.
     * @returns {String}
     */
    vendorCollectionUrl() {
      if (this.product.vendorLink) {
        return this.product.vendorLink
      }

      if (!this.product.vendor) {
        return ''
      }

      return `${cnvs.routes.normalisedRoot}collections/vendors?q=${encodeURI(this.product.vendor)}`
    },
  },
}
</script>

<style lang="scss">
@import './product-details';
</style>
